<template>
  <div>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <validated-input-box
      id="loginFieldTopupOnce"
      ref="loginField"
      :validation-reg-exp="numberRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_ERROR')"
      :label="this.$i18n.t('COMMON.LOGIN_NUMBER')"
      placeholder="6789123456789"
      name="loginField"
    />
    <select-box
      id="amountSelectBox"
      ref="amountSelect"
      :label="this.$i18n.t('COMMON.AMOUNT')"
      initial-option="44"
    >
      <option
        value="44"
        selected
      >
        10,- EUR
      </option>
      <option value="73">
        15,- EUR
      </option>
      <option value="45">
        20,- EUR
      </option>
      <option value="79">
        25,- EUR
      </option>
      <option value="85">
        30,- EUR
      </option>
      <option value="46">
        40,- EUR
      </option>
      <option value="91">
        50,- EUR
      </option>
      <option value="97">
        100,- EUR
      </option>
    </select-box>
    <p>
      <icon-info />
      {{ this.$i18n.t('TOPUP.ONCE.UNZER_INFO') }}
    </p>
    <submit-button
      id="topupOnceSubmitButton"
      :label="this.$i18n.t('COMMON.NEXT')"
      :on-click="submitForm"
      :disabled="!frcResponse"
    />
    <friendly-captcha-field
      ref="captcha"
      v-model="frcResponse"
    />
  </div>
</template>

<script>
import Regex from '@/constants/regex.json';
import FriendlyCaptchaField from '@/components/common/FriendlyCaptchaField.vue';

const RESP_VALIDATION_ERROR=1;
const RESP_MSISDN_NOT_FOR_TOPUP=2;
const RESP_MAX_LIMIT_REACHED=3;
const RESP_SIM_NOT_REGISTERED=6;
const RESP_OTHER_ERROR=9999;

export default {
  name: 'TopUpMpay',
  components: { FriendlyCaptchaField },
  data: function() {
    return {
      inProgress: false,
      amount: 44,
      voucherValues: {"44":10, "73": 15, "45": 20, "79": 25, "85": 30, "46": 40, "91": 50, "97": 100},
      frcResponse: null,
    };
  },
  computed: {
    numberRegex: function() {
      return Regex.NUMBER;
    },
    voucherValue: function() {
      return this.voucherValues[this.amount];
    },
  },
  mounted: function() {
    this.$refs.loginField.setFieldValue(this.$store.getters.userDetail.msisdn);
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.loginField.isValidBeforeSubmit();
      return isValid;
    },
    submitForm: function() {
      if (this.isFormValid() && !this.inProgress && this.$refs.captcha.isValid()) {
        this.inProgress = true;
        const mpayRequest = {
          msisdn: this.$refs.loginField.getFieldValue(),
          voucherCode: this.$refs.amountSelect.getValue(),
        };
        this.$http.post('api/protected/dreitvkarte/topup/mpay24', mpayRequest, {
          headers: {
            'friendly-captcha-version': 'v2',
            'friendly-captcha-response': this.frcResponse
          }
        })
          .then( (response) => {
            this.processSuccessfulCallResponse(response.data);
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
          })
          .finally(() => {
            this.inProgress = false;
            this.$refs.captcha.reset();
          })
      }
    },
    processSuccessfulCallResponse: function(response) {
      // we store value of selected voucher to vuex and it stores it to localStorage,
      // so we can load and use it when customer comes back to our app in success/cancel/erorr page

      this.$store.commit("setLastTopupValue", this.voucherValue);

      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Started', value: this.voucherValue, noninteraction: false });
      window.location = response.mpayUrl;
    },

    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - no data', value: this.voucherValue, noninteraction: false });
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.VALIDATION_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - validation error', value: 0, noninteraction: false });
          break;
        case RESP_MSISDN_NOT_FOR_TOPUP:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - MSISDN not for topup', value: 0, noninteraction: false });
          break;
        case RESP_MAX_LIMIT_REACHED:
          this.$store.commit("setErrorMessage", this.$i18n.t('TOPUP.ONCE.MSISDN_MAX_LIMIT_REACHED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - max limit reached', value: 0, noninteraction: false });
          break;
        case RESP_SIM_NOT_REGISTERED:
          this.$store.commit("setErrorMessage", this.$i18n.t('TOPUP.ONCE.TOPUP_FORBIDDEN_NOT_REGISTERED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - USIM not legally registered', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error - '+responseCode, value: 0, noninteraction: false });
      }
    },
  },
};
</script>

<style lang="scss" src="../../components/loading/loading.scss">
</style>
